import { AudioType } from 'modules/AnchorAPI/v3/episodes/fetchEpisodeAudio';
import { getApiUrl } from '../../../Url';

/* 
  New endpoint to replace and deprecate public-website 
  API /api/podcastepisode/:podcastEpisodeId into server-api. 
  
  TODO: complete refactor of EpisodeEditorPublish,
  EpisodeEditorPublishContainer, EpisodeMetadataPublishContainer to 
  remove redux and transition fully to pull from this new endpoint. 
  More info https://anchorfm.atlassian.net/browse/WHEEL-839
*/

type FetchEpisodeOverviewParams = {
  webEpisodeId: string;
};

export type EpisodeAudios = {
  url: string;
  caption: string;
  duration: number;
  webAudioId: string;
  color: string;
  type: AudioType;
  audioTransformationName?: string;
  derivedFromAudioId?: boolean;
  audioTransformationStatus:
    | 'waiting'
    | 'started'
    | 'failed'
    | 'finished'
    | null;
  fileSize: number;
  created: string;
  modified: string;
  sort: number;
  userId: number;
  isAdSlotEnabled: boolean;
};

export type FetchEpisodeOverviewResponse = {
  episodeAudios: EpisodeAudios[];
  title: string;
  totalDuration: number;
  totalSize: number;
  videoPodcastingEpisode: boolean;
  isPaywallContent?: boolean;
  isPublished: boolean;
  userId: number;
  description: string;
  imageId: string | null;
  isDeleted: boolean;
  hourOffset: number;
  created: string;
  modified: string;
  publishOn: null | string;
  createdUnixTimestamp: null | number;
  publishOnUnixTimestamp: null | number;
  containsMusicSegments: boolean;
  creationPlatform: string;
  episodeImage: string;
  ipAddressAtPublish: string;
  isAdSlotEnabled: boolean;
  megaphoneDownloadUrl: string;
  megaphoneId: string;
  podcastEpisodeIsExplicit: boolean;
  podcastEpisodeType: string;
  podcastEpisodeUuid: string;
  processingRequestUuid: string;
  shareLinkPath: string;
  shareLinkEmbedPath: string;
  isDraft: boolean;
  webEpisodeId: string;
  webStationId: string;
};

export async function fetchEpisodeOverview({
  webEpisodeId,
}: FetchEpisodeOverviewParams): Promise<FetchEpisodeOverviewResponse> {
  try {
    const response = await fetch(
      getApiUrl({
        path: `episodes/webEpisodeId:${webEpisodeId}/overview`,
        queryParameters: {
          returnWebIds: true,
        },
      }),
      {
        method: 'GET',
        credentials: 'same-origin',
      }
    );

    if (response.ok) {
      return response.json();
    }
    throw new Error('Error fetching episode overview');
  } catch (e) {
    throw new Error(e.message);
  }
}
